import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProjectConstants } from '../project-constants';



@Component({
  selector: 'app-grievance-dialog',
  templateUrl: './grievance-dialog.component.html',
  styleUrls: ['./grievance-dialog.component.scss'],
})
export class GrievanceDialogComponent implements OnInit {
successTitle=ProjectConstants.grievanceSuccessTitle
successTitleMsg=ProjectConstants.grievanceSuccessTitleMSg
okMsg=ProjectConstants.okMsg
  constructor(public router: Router,
    public dialogRef: MatDialogRef<GrievanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  //close dialog after clickingon ok btn
  gotoList() {
    this.dialogRef.close();
  }
  //
}
